import Schema from './Schema'
import FieldSelect from '../fields/FieldSelect'
export default class SchemaSelect extends Schema {
  constructor(label, key, items, rules, options, on) {
    super(options)
    FieldSelect.call(this, label, key, items, rules, options, on)
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaSelect.js